module.exports = __webpack_public_path__ + "static/media/1st-Left.42822395.webp";